import React, {useEffect} from "react";
import { Button, Form, } from 'react-bootstrap';
import './StepTwo.scss';
import ScrollAnimation from 'react-animate-on-scroll';
import loadable from '@loadable/component'
import $ from 'jquery'
import AddressSearch from 'react-loqate';


const AddressSearchInput = (props) => {
  // console.log(props)
  // var SeLAdd = sessionStorage.getItem('SelectedAdress')
  // document.getElementById('address').value = SeLAdd
  
  return (
          <div className="custom-float">                
              <input
                  name="address"
                  placeholder="Start typing your address"
                  autocomplete="off"
                  type="text"
                  id="address"
                  class="form-control"
                  {...props}
                  value={props.addressLabel}
                  required="true"
                  
              />

          </div>
  );
};


const StepTwo = (props) => {
  useEffect(() => {
    var addressLabel = sessionStorage.getItem('addressLabel') != null ? sessionStorage.getItem('addressLabel') : ''
    document.getElementById('address').value = addressLabel
  }, []);

  // const AddressLoquate = loadable(() => import('./address-search'))
  const handleAddress = (address) => {
    debugger
    document.getElementById('address').value = address.Label.replace(/\n/g, ", ")
    document.getElementById('addressBuildingName').value = address.BuildingName
    document.getElementById('addressBuildingNumber').value = address.BuildingNumber
    document.getElementById('addressPostalCode').value = address.PostalCode
    document.getElementById('addressSubBuilding').value = address.SubBuilding
    document.getElementById('addressStreet').value = address.Street
    sessionStorage.setItem('addressBuildingName', address.BuildingName)
    sessionStorage.setItem('addressBuildingNumber', address.BuildingNumber)
    sessionStorage.setItem('addressPostalCode', address.PostalCode)
    sessionStorage.setItem('addressSubBuilding', address.SubBuilding)
    sessionStorage.setItem('addressStreet', address.Street)
    sessionStorage.setItem("addressLabel", address.Label.replace(/\n/g, ", "))

    if(!address){
      $('.address-group').addClass('field-invalid');
      $('.error').html("<p>Please enter property address</p>");    }
    else {
      $('.address-group').removeClass('field-invalid');
      $('.error').html('');
    }

  }
  return (

    <div className="steptwo address-blk">
      <div className="d-lg-block">
        {/* <ScrollAnimation animateIn='fadeIn' animateOnce={true}> */}
          <div onClick={props.step === 0 ? props.handleBack : props.previous} onKeyPress={props.step === 0 ? props.handleBack : props.previous} className="back_icon"><i className="icon-back"></i> Back</div>
        {/* </ScrollAnimation> */}
      </div>
      <ScrollAnimation animateIn='fadeIn' animateOnce={true}>
        <h2>Thanks {props.name}. Now we need to know your property details.</h2>
      </ScrollAnimation>
      <div className="form-field">
        {/* {JSON.stringify(props.address)} */}
      <input id="addressBuildingName" type="hidden" name="addressBuildingName" />
          <input id="addressBuildingNumber"  type="hidden" name="addressBuildingNumber" />
          <input id="addressPostalCode"  type="hidden" name="addressPostalCode" />
          <input id="addressSubBuilding"  type="hidden" name="addressSubBuilding" />
          <input id="addressStreet"  type="hidden" name="addressStreet" />
          <input id="stepOnename"  type="hidden" name={props.name} />
          <input id="stepOneemail"  type="hidden" name={props.email} />
          <input id="stepOnephone"  type="hidden" name={props.phone} />
          

        <ScrollAnimation animateIn='fadeIn' animateOnce={true}>
        {/* <div className="option-bx"> */}
            <h3>What’s the address of your property?</h3>
            <div className="form-section address-group">
            <div className="form-block-col">
            {/* <div className="d-flex"> */}
      <Form.Group className="address-input">
      <AddressSearch
                        locale="en_GB"
                        apiKey={process.env.GATSBY_LOQATE_API_KEY}
                        countries={['GB']}
                        components={{ Input: AddressSearchInput }}
                        className="address-search-box"
                        inputClassname="address form-control"
                        listClassname="address-options"
                        listItemClassname="address-option"
                        onSelect={(address) => handleAddress(address)}
                        onChange={props.onChange}
                        
                        />
                  {/* <Form.Control className={props.addressError ? 'error-border' : ''} autoComplete="off" value={props.address} onChange={props.onChange} name="address" type="text" placeholder="" /> */}
                  {/* {props.addressError && */}
                  <div className="error">
                    
                  </div>
                  {/* } */}
                </Form.Group>
                </div>
            </div>

        <div className="option-bx">
            <h3>Would you like to Sell or Let your property?</h3>
            <div className="d-flex">
              <Form.Group controlId="sellYes">
                <Form.Check
                onChange={props.onChange}
                  inline
                  checked={props.propertySell === 'Sell'}
                  type="radio"
                  value="Sell"
                  name="sellorlet"
                  label="Sell" />
              </Form.Group>
              <Form.Group controlId="sellNo">
                <Form.Check
                  onChange={props.onChange}
                  checked={props.propertySell === 'Let'}
                  inline
                  type="radio"
                  value="Let"
                  name="sellorlet"
                  label="Let" />
              </Form.Group>
              {!props.propertySell && props.submitted &&
                    <div className="error">
                      Please choose an option.
                    </div>
                    }
            </div>
            </div>
            <Form.Group className="btn-bk-set">
                  <Button className="order-md-2" variant="primary" onClick={props.previous}>Back</Button>
                    <Button className="order-md-1" variant="primary" onClick={props.next}>Next</Button>
                  </Form.Group>
        </ScrollAnimation>
      </div>
    </div>
  )
}



export default StepTwo